<script>
  import * as d3 from "d3";
  import * as topojson from "topojson-client";

  import Map from "./components/Map.svelte";
  import Loader from "./components/Loader.svelte";
  import OnboardingModal from "./components/OnboardingModal.svelte";

  let showOnboarding = true;
  let triggerBorderPulse = false;

  const handleOnboardingClose = () => {
    showOnboarding = false;
    // Trigger border pulse animation
    triggerBorderPulse = true;
    setTimeout(() => {
      triggerBorderPulse = false;
    }, 2000);
  };

  const dataFilePromises = [
    d3.json("data/us_states.json"),
    d3.json("data/global_stopping_features.json"),
    d3.json("data/active_nwis_sites.json"),
    d3.csv("data/name_overrides.csv"),
    d3.json("data/historic_provinces.json"),
  ];

  const dataLoad = Promise.all(dataFilePromises).then(async (data) => {
    const states = topojson.feature(data[0], data[0].objects.states).features;
    const stoppingFeatures = topojson.feature(
      data[1],
      data[1].objects.global_stopping_features
    ).features;

    const activeNWISSites = data[2].sites;
    const nameOverrides = {};
    data[3].forEach((d) => {
      nameOverrides[d['levelpathid']] = {
        feature_name: d['feature_name']
      };
    });

    const historicProvinces = data[4].provinces;

    return [states, stoppingFeatures, activeNWISSites, nameOverrides, historicProvinces];
  });
</script>

{#await dataLoad}
  <Loader />
{:then data}
  <Map
    bounds={[
      [30, 1],
      [51, 17],
    ]}
    stateBoundaries={data[0]}
    stoppingFeatures={data[1]}
    activeNWISSites={data[2]}
    nameOverrides={data[3]}
    historicProvinces={data[4]}
    visibleIndex={1}
    addTopo={true}
    mapStyle={"mapbox://styles/mapbox/satellite-v9"}
    advancedFeaturesOn={false}
    borderPulse={triggerBorderPulse}
  />

  <OnboardingModal
    visible={showOnboarding}
    on:close={handleOnboardingClose}
  />
{/await}
